<form class="popupForm" style="min-height: 300px;" [formGroup]="componentForm">
  <div class="common" mat-dialog fxLayout="column" fxLayoutAlign="space-between" style="min-height: inherit;">
    <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between end">
      Export article to the static Web Page
      <button mat-icon-button mat-dialog-close id="close-upload" alt="close" title="close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="when-fx-layout-broke" style="display: flex !important; min-height: 300px;">
      <div class="internal-spinner" *ngIf="state === 'loading'">
        <svg class="spinner" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
        </svg>
      </div>
      <div *ngIf="state === 'error'">
        Article check error. <br>{{errMsg}}
      </div>
      <div *ngIf="state === 'start_export'">
        Add page name to export article:
      </div>
      <div *ngIf="state === 'show_export_details'">
        This article has been exported here:
      </div>
      <mat-form-field *ngIf="state==='start_export' || state==='show_export_details'"
                      appearance="outline" color="accent" style="width: 100%">
        <mat-label>Web page address</mat-label>
        <input matInput id="mkdir-name-input" type="text"
               (keydown)="$event.stopPropagation()" (keyup)="$event.stopPropagation()" (keydown.enter)="handleSubmit($event)"
               cdkFocusInitial formControlName="textInput">
      </mat-form-field>
      <div fxLayout="row" fxLayoutAlign="start center" class="field-error-message"
           *ngIf="validationResult && !validationResult.isValid && validationResult.message">
        <mat-icon color="warn">error</mat-icon><span>{{ validationResult.message}}</span>
      </div>
      <div fxLayout="row" fxLayoutAlign="start center" class="field-info-message"
           *ngIf="state==='start_export'">
        <mat-icon color="accent">info</mat-icon><span>example: smuzzi.html</span>
      </div>
    </mat-dialog-content>
    <div fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="10px">
      <button mat-button class="cancel widerButton font16" (click)="onNoClick()">
        Cancel
      </button>
      <button *ngIf="state === 'show_export_details'" type="submit" class="widerButton font16" mat-raised-button color="accent" (click)="handleSubmit()">
        Update Exported Article
      </button>
      <button *ngIf="state === 'start_export'" type="submit" class="widerButton font16" mat-raised-button color="accent" (click)="handleSubmit()">
        Export Article
      </button>
    </div>
  </div>
</form>
